import { parseToRgba, rgba as rgba$1 } from 'color2k';

const rgba = (firstValue, secondValue, thirdValue, fourthValue) => {
  if (typeof firstValue === "string" && typeof secondValue === "number") {
    const rgbaValue = parseToRgba(firstValue);
    return rgba$1(rgbaValue[0], rgbaValue[1], rgbaValue[2], secondValue);
  }
  if (typeof firstValue === "string") {
    const rgbaValue = parseToRgba(firstValue);
    return rgba$1(rgbaValue[0], rgbaValue[1], rgbaValue[2], 1);
  }
  if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number") {
    if (typeof fourthValue === "number") {
      return rgba$1(firstValue, secondValue, thirdValue, fourthValue);
    }
    return rgba$1(firstValue, secondValue, thirdValue, 1);
  }
  throw new Error("Invalid arguments to rgba function.");
};

export { rgba };
